import React from 'react';

/**
 * Stylized Buddha head silhouette icon.
 * Follows the same stroke-based API as lucide-react icons.
 * Depicts: ushnisha (topknot) + head + eyes closed in meditation + hint of shoulders.
 */
export default function BuddhaIcon({ size = 24, className = '', strokeWidth = 1.8, ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...rest}
    >
      {/* Ushnisha (topknot) — the wisdom bump */}
      <path d="M12 3c.9 0 1.6.7 1.6 1.6 0 .5-.2.9-.5 1.2" />
      {/* Small dot on top of ushnisha */}
      <circle cx="12" cy="3" r="0.4" fill="currentColor" />
      {/* Head outline (rounded) */}
      <path d="M6.5 11c0-3.3 2.5-6 5.5-6s5.5 2.7 5.5 6c0 2.3-1.2 4.2-2.9 5.2" />
      <path d="M8.9 16.2C7.2 15.2 6 13.3 6 11" />
      {/* Ears (long, meditation) */}
      <path d="M7 11.5c-.6 0-1 .4-1 1v1c0 .6.4 1 1 1" />
      <path d="M17 11.5c.6 0 1 .4 1 1v1c0 .6-.4 1-1 1" />
      {/* Closed eyes (peaceful, meditation) */}
      <path d="M9.5 10.8c.3-.3.9-.3 1.2 0" />
      <path d="M13.3 10.8c.3-.3.9-.3 1.2 0" />
      {/* Urna (dot between brows) */}
      <circle cx="12" cy="9.2" r="0.35" fill="currentColor" />
      {/* Slight smile */}
      <path d="M10.8 13.2c.4.3 1 .3 1.4 0" />
      {/* Shoulders / robe suggestion */}
      <path d="M4.5 20c1.3-1.8 3.9-3 7.5-3s6.2 1.2 7.5 3" />
    </svg>
  );
}
